import { isContactId } from "./contact-blocks";

export type ContentReportContext =
  | { kind: "conversation"; id: string }
  | { kind: "squad-moment"; id: string; squadId: string };

/** References only. Never put private message text or names into the URL. */
export function parseContentReportContext(value: unknown): ContentReportContext | null {
  if (typeof value !== "string" || value.length > 300) return null;
  try {
    const parsed: unknown = JSON.parse(value);
    if (!parsed || typeof parsed !== "object" || !("kind" in parsed) || !("id" in parsed) || !isContactId(parsed.id)) return null;
    if (parsed.kind === "conversation") return { kind: "conversation", id: parsed.id };
    if (parsed.kind === "squad-moment" && "squadId" in parsed && isContactId(parsed.squadId)) {
      return { kind: "squad-moment", id: parsed.id, squadId: parsed.squadId };
    }
  } catch {
    // A malformed reference must never be sent as a valid content report.
  }
  return null;
}

export function contentReportHref(context: ContentReportContext): string {
  const checked = parseContentReportContext(JSON.stringify(context));
  if (!checked) return "/feedback";
  return `/feedback?context=content-report&report=${encodeURIComponent(JSON.stringify(checked))}`;
}

export function contentReportLabel(context: ContentReportContext): string {
  return context.kind === "conversation" ? "conversation" : "Squad moment";
}
